import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setAddresses } from "../../actions/user";
import { fetchApi } from "../../api";
import Addresses from "../../components/Addresses";
import Container from "../../components/Container";
import Content from "../../components/Content";
import Header from "../../components/Header";

function Address({ setAddresses, navigation }) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    fetchApi({
      path: "/users/me/addresses",
    }).then((res) => {
      if (res.results) {
        setAddresses(res.results);
      }
      setIsReady(true);
    });
  }, []);

  return (
    <Container>
      <Header
        title="My Addresses"
        backButton
        navigation={navigation}
        rightIcons={[]}
      />
      <Content loading={!isReady}>
        <Addresses />
      </Content>
    </Container>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setAddresses: (data) => dispatch(setAddresses(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Address);
